module.exports = __webpack_public_path__ + "50f945669b78e9786de047e8e5605e37.MP3";